import ToastComponent from '@/components/toast'
import { app, ios } from '@beastshop/browser'
import bridge from '@beastshop/bridge'
let $vm
let _resolve
let _reject

(function () {
  function install (Vue) {
    const Toast = Vue.extend(ToastComponent)
    let toast = (content) => {
      if(app()){
        return bridge.toast(content)
      }
      if(!content){
        throw new Error(`Plugins $toast args must be 'String' `);
      }
      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        })
        document.body.appendChild($vm.$el)
      }
      $vm.show = true
      $vm.mask = false
      $vm.toast = true
      $vm.autoClose = true
      $vm.content = content
      $vm.$on('toast-hide', function(msg) {
        _resolve()
      });
      return new Promise((resolve) => {
        _resolve = resolve
      })
    }

    let alert = (option) => {
      if(!option){
        throw new Error(`Plugins $alert args must be 'String' or 'Object'`);
      }
      if(app()){
        return bridge.alert(option)
      }

      // if (!/^[\u4e00-\u9fa5_a-zA-Z0-9@()!：；:,。"'\[\]]+$/g.test(option)) {
      //   throw new Error(`Plugins $alert args must be 'String' or 'Object'`);
      // }

      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        })
        document.body.appendChild($vm.$el)
      }
      $vm.show = true
      $vm.maskTouchHide = true
      $vm.alert = true
      if(typeof option === 'object'){
        option.buttonText && ($vm.primary = option.buttonText)
        $vm.title = option.title
        $vm.content = option.content
        $vm.buttonEmphasize = option.buttonEmphasize
      }else{
        $vm.content = option
      }
      $vm.$on('alert-hide', function(msg) {
        _resolve()
      });
      return new Promise((resolve) => {
        _resolve = resolve
      })
    }

    let confirm = (option) => {
      if(!option){
        throw new Error(`Plugins $confirm args must be 'String' or 'Object'`);
      }
      if(app() && ios()){
        return bridge.confirm(option)
      }
      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        })
        document.body.appendChild($vm.$el)
      }
      $vm.show = true
      $vm.confirm = true
      if(typeof option === 'object'){
        option.primaryButtonText && ($vm.primary = option.primaryButtonText)
        option.secondaryButtonText && ($vm.secondary = option.secondaryButtonText)
        $vm.content = option.content
        $vm.title = option.title
        $vm.primaryButtonEmphasize = option.primaryButtonEmphasize
        $vm.secondaryButtonEmphasize = option.secondaryButtonEmphasize
      }else{
        $vm.title = option
      }
      $vm.$on('confirm-ensure', function() {
        _resolve()
      });
      $vm.$on('confirm-cancel', function() {
        _reject()
      });
      return new Promise((resolve,reject) => {
        _resolve = resolve
        _reject = reject
      })
    }
    // if (!Vue.$beast) {
    //   Vue.$beast = {}
    // }

    // Vue.$beast.toast = toast
    // Vue.$beast.alert = alert
    // Vue.$beast.confirm = confirm

    Vue.mixin({
      created: function () {
        this.$toast = toast
        this.$alert = alert
        this.$confirm = confirm
      }
    })
  }

  if (typeof exports == "object") {
    module.exports = install
  } else if (typeof define == "function" && define.amd) {
    define([], function(){ return install })
  } else if (window.Vue) {
    Vue.use(install)
  }

})()



// WEBPACK FOOTER //
// ./static/plugins/toast/index.js